import { Flex, Progress, ProgressProps, forwardRef } from '@chakra-ui/react';
import _ from 'lodash';
import { useMemo } from 'react';

export interface ColorfulBarProps {
  values: any[];
  colorSchemes: string[];
  max: number;
  render?: React.ComponentType<ProgressProps>;
}

export const ColorfulBar = forwardRef((props: ColorfulBarProps, ref) => {
  const { values, colorSchemes, max, render, ...other } = props;

  const total = useMemo(
    () => _.sum(values.map((v) => parseFloat(v || '0'))),
    [values]
  );

  const tracks = useMemo(() => {
    return values.map((v, i) => {
      const rawValue = parseFloat(v || '0');
      return {
        color: colorSchemes[i],
        rawValue,
        value: (parseFloat(v || '0') / (max || total)) * 100,
      };
    });
  }, [values, colorSchemes, max, total]);

  const Element = render || Progress;

  return (
    <Flex dir="horizontal" ref={ref} {...other}>
      {tracks.map((t, i) => (
        <Element key={i} w={`${t.value}%`} value={100} colorScheme={t.color} />
      ))}
      <Element flex="1" value={0} />
    </Flex>
  );
});
